import React from 'react';
import PopupContainer from '../../../../src/web/containers/PopupContainer';

const propTypes = {};

const defaultProps = {};

const PopUp = props => <PopupContainer {...props} />;

PopUp.propTypes = propTypes;
PopUp.defaultProps = defaultProps;

export default PopUp;
